import { getQueryParams } from './queryParams';

export function useGetReturnUrl() {
    const queryParams = getQueryParams<{ returnUrl: string }>();
    return queryParams.returnUrl;
}
